window.addEventListener("DOMContentLoaded", () => {
    const checkNavBackground = () => {
        let header = document.querySelector("header");
        if (window.scrollY > 50) {
            header.classList.add("bg-liveBlue/80");
            header.classList.add("drop-shadow-lg");
        } else {
            header.classList.remove("bg-liveBlue/80");
            header.classList.remove("drop-shadow-lg");
        }
    };

    const checkFooterBackground = () => {
        let footer = document.querySelector("footer");
        let hero = document.querySelector(".nodetype-element--jvmtech-life-content-stage");
        if (window.scrollY > 50 || (hero && hero.getBoundingClientRect().height > window.innerHeight)) {
            footer.classList.add("bg-liveBlue/80");
            footer.classList.add("drop-shadow-lg");
        } else {
            footer.classList.remove("bg-liveBlue/80");
            footer.classList.remove("drop-shadow-lg");
        }
    };

    const debounce = (func, wait) => {
        let timeout;
        return function(...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    };

    const debouncedCheckNavBackground = debounce(checkNavBackground, 10);
    window.addEventListener("scroll", debouncedCheckNavBackground);
    checkNavBackground();

    const debouncedCheckFooterBackground = debounce(checkFooterBackground, 10);
    window.addEventListener("scroll", debouncedCheckFooterBackground);
    checkFooterBackground();

    const debouncedResize = debounce(checkFooterBackground, 10);
    window.addEventListener("resize", debouncedResize);
});
